import Excel from "exceljs";
import FileSaver from "file-saver";
import React from "react";
// Mui Styles
// import { styled } from "@mui/material/styles";
import DownloadIcon from "@mui/icons-material/Download";
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "../styles/mui/globalStyles";
import { InputTheme, TableListTheme } from "../styles/mui/tableListTheme";

// Mui
import DataTable from "@/components/dataTable";
import { ReturnInvoiceTableColumn } from "@/config/tableColumnConfig";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
//lodash
import _ from "lodash";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// Navigate
import { useNavigate } from "react-router-dom";

// Components
import DateSelection from "@/components/dateSelection";
import Layout from "../components/layout";
import Title from "../components/title";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Zoom Images
// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// Fetch
import { getReturnInvoice } from "../fetch/fetchStock";

// Config
// import connectConfig from "../config/connectConfig";
// import { exportCSVFile } from "../config/csvConfig";
// import { CustomerDailyTableColumn } from "../config/tableColumnConfig";

// create  a header for csv library
import { useCurrentAction } from "@/hooks/user";

const ReturnInvoicePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();
  const location = useLocation();

  const { pathname } = location;
  // States
  const defaultStartDate = moment().startOf("month");
  const defaultEndDate = moment().endOf("month");

  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );
  const [selectedShop, setSelectedShop] = React.useState(0);
  const [rowsData, setRowsData] = React.useState(null);
  const [filteredItems, setFilteredItems] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const handleDownload = () => {
    const workbook = new Excel.Workbook();
    const sheet = workbook.addWorksheet("退倉紀錄");
    sheet.columns = [
      { header: "Shop", key: "shop" },
      { header: "Staff Code", key: "staff-code" },
      { header: "Promoter", key: "promoter" },
      { header: "M18 Product Code", key: "m18-product-code" },
      { header: "Item Name", key: "item-name" },
      { header: "Qty", key: "qty" },
      { header: "Reason", key: "reason" },
      { header: "time", key: "time-created" },
      { header: "Area Manager", key: "area-manager" },
    ];
    let currentRow = 2;
    _.forEach(rowsData, (row) => {
      const sum = _.reduce(
        row.item,
        (prev, curr) => {
          return curr.return_qty >= 0 ? prev + curr.return_qty : prev;
        },
        0
      );
      sheet.addRow([
        row.work_shortcode,
        row.alias,
        row.staff_code,
        "",
        "",
        sum,
        row.reason,
        moment(row.time_created).format("YYYY-MM-DD HH:mm:ss"),
        row.am_alias,
      ]);
      sheet.getRow(currentRow).outlineLevel = 0;
      sheet.getRow(currentRow).hidden = false;

      currentRow++;
      _.forEach(row.item, (item) => {
        sheet.addRow([
          "",
          "",
          "",
          item.m18_product_code,
          item.item,
          item.return_qty,
          "",
          "",
        ]);
        sheet.getRow(currentRow).outlineLevel = 1;
        sheet.getRow(currentRow).hidden = true;

        currentRow++;
      });
    });
    sheet.columns.forEach((column) => {
      column.width = 20;
    });
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(
        blob,
        `退倉紀錄(${moment(startDate).format("YYYY-MM-DD")} - ${moment(
          endDate
        ).format("YYYY-MM-DD")})`
      );
    });
  };

  // Fetch

  const fetchReturnInvoice = async (selectedShop, startDate, endDate) => {
    try {
      setDataTableLoading(true);
      await new Promise((resolve, _) => resolve(setIsLoading((prev) => !prev)));
      await getReturnInvoice(undefined, selectedShop, startDate, endDate).then(
        (data) => {
          if (data && data.results) {
            setTimeout(() => {
              setRowsData(data.data);
              setIsLoading((prev) => !prev);
            }, 300);
          } else {
            setRowsData([]);
            setTimeout(() => setIsLoading((prev) => !prev), 300);
          }
        }
      );
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    if (rowsData === null) {
      setRowsData([]);
    }
    setFilteredItems(rowsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsData]);

  React.useEffect(() => {
    fetchReturnInvoice(
      selectedShop,
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD")
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedShop, startDate, endDate]);

  moment.updateLocale("zh-hk", {
    weekdaysShort: ["日", "一", "二", "三", "四", "五", "六"],
  });
  const onCellClick = (data) => {
    navigate(`/returnInvoice/${data.invoice_id}`);
  };
  const getRowId = (row) => {
    return row.invoice_id;
  };
  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={23}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`退倉清單`}
        history={() => navigate(-1)}
        children={
          actions?.download ? (
            <IconButton component="label" onClick={handleDownload}>
              <DownloadIcon />
            </IconButton>
          ) : null
        }
      />

      <StyledPaper page={"yes"} alignItems="left">
        <Grid container spacing={2}>
          <ThemeProvider theme={InputTheme}>
            <DateSelection
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
            ></DateSelection>
          </ThemeProvider>
        </Grid>
      </StyledPaper>
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={filteredItems?.length > 0 ? filteredItems : []}
            columns={ReturnInvoiceTableColumn}
            onCellClick={(params) => onCellClick(params)}
            checkboxSelection={false}
            getRowId={getRowId}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default ReturnInvoicePage;
